import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from '../../shared/components/Table';
import { CheckValue } from '../../services/types/Misc';
import CheckBox from '../../shared/components/CheckBox';
import { CustomFilterItem } from '../../services/types/CustomFilter';

interface Props {
  cells: Cell<CustomFilterItem>[];
  hideColumns: string[];
  setHideColumn: (id: string, value: boolean) => void;
  disabledColumns?: string[];
}

const SimpleColumnChecks: React.FC<Props> = ({
  cells,
  hideColumns,
  setHideColumn,
  disabledColumns,
}) => {
  const { t } = useTranslation();
  const columns = cells.map((c) => ({
    id: c.name || 'id',
    text: t(`${c.tPrefix || ''}${c.name || ''}`),
    htmlId: `chk${c.name}`,
    checked: hideColumns.indexOf(c.name || '') === -1,
  }));
  const columnCheck = (element: CheckValue) => {
    const disabled: boolean = (disabledColumns && disabledColumns.includes(element.id)) || false;

    return !disabled ? (
      <CheckBox key={element.id} element={element} onChange={setHideColumn} />
    ) : (
      <CheckBox key={element.id} element={element} onChange={() => {}} disabled={disabled} />
    );
  };

  return <div className="cols-container">{columns.map((c) => columnCheck(c))}</div>;
};

export default React.memo(SimpleColumnChecks);
